import { useSync } from '@grandvisionhq/lib-utils-w3c';

const useWishlistSync = (refetch)=>{
    return useSync('wishlist_channel', refetch);
};

export { useWishlistSync };
//# sourceMappingURL=use-wishlist-sync.js.map
